import { render, staticRenderFns } from "./InviteFriendList.vue?vue&type=template&id=29aacb67&"
import script from "./InviteFriendList.vue?vue&type=script&lang=js&"
export * from "./InviteFriendList.vue?vue&type=script&lang=js&"
import style0 from "./InviteFriendList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports